(function () {
  // Free shipping thresholds per presentment currency (cents). Values = 2 decks at
  // the FTG single-deck price in that market. AU set at $45 (2 decks at standard $22.95).
  // Non-listed currencies render a static truthful message (no numeric claim).
  var THRESHOLDS = { "AUD": 4500 };
  var DP_VARIANT = null;        // Double Pack variant id (always free via own profile)
  var DEFAULT_PROFILE = null;   // variant ids that count toward the threshold
  var el = null;
  var lastState = null;     // last rendered state — confetti fires on the transition INTO unlocked
  var abortCtrl = null;
  var currentVariantId = null;  // the PDP's own product variant (for quantity projection)
  var currentUnitPrice = null;  // presentment price in cents of the PDP variant

  function cartUrl() {
    return (window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root : '/') + 'cart.js';
  }

  function formatMoney(cents, currency) {
    try {
      return new Intl.NumberFormat(undefined, { style: 'currency', currency: currency }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2) + ' ' + currency;
    }
  }

  function render(state, data) {
    var prevState = lastState;
    lastState = state;
    el.classList.toggle('ftg-fsbar--unlocked', state === 'UNLOCKED');
    var track = el.querySelector('.ftg-fsbar__track');
    var fill = el.querySelector('.ftg-fsbar__fill');
    var msg = el.querySelector('.ftg-fsbar__msg');

    if (state === 'EMPTY') {
      track.hidden = true;
      msg.textContent = "FREE shipping when you grab 2 decks. Or just grab the Double Pack, we've already sorted it.";
      return;
    }
    if (state === 'CURRENCY_FALLBACK') {
      track.hidden = true;
      msg.textContent = 'FREE shipping when you grab 2 decks. Or grab the Double Pack, we\'ve already sorted it.';
      return;
    }
    if (state === 'DP_ONLY') {
      track.hidden = false;
      fill.style.width = '100%';
      track.setAttribute('aria-valuenow', '100');
      msg.textContent = 'Nice one, your Double Pack ships FREE. Always does.';
      return;
    }
    if (state === 'DP_PARTIAL') {
      track.hidden = false;
      var pct = Math.min(100, (data.eligible / data.threshold) * 100);
      fill.style.width = pct + '%';
      track.setAttribute('aria-valuenow', String(Math.round(pct)));
      var remaining = formatMoney(data.threshold - data.eligible, data.currency);
      msg.innerHTML = 'Your Double Pack ships FREE. Chuck in <strong>' + remaining + '</strong> more on the rest and we\'ll cover that too.';
      return;
    }
    if (state === 'UNLOCKED') {
      track.hidden = false;
      fill.style.width = '100%';
      track.setAttribute('aria-valuenow', '100');
      msg.textContent = 'FREE shipping unlocked. Nice one.';
      if (prevState !== 'UNLOCKED') {
        try {
          var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
          if (typeof confetti === 'function' && !reduceMotion) {
            confetti({ particleCount: 140, spread: 80, origin: { y: 0.55 }, colors: ['#ffd700', '#ff5a00', '#111111', '#ffffff', '#3aa757'] });
            setTimeout(function () {
              confetti({ particleCount: 60, angle: 60, spread: 60, origin: { x: 0, y: 0.7 } });
              confetti({ particleCount: 60, angle: 120, spread: 60, origin: { x: 1, y: 0.7 } });
            }, 350);
          }
        } catch (e) { /* confetti is decorative — never break the bar */ }
      }
      return;
    }
    if (state === 'PROGRESS') {
      track.hidden = false;
      var pct2 = Math.min(100, (data.eligible / data.threshold) * 100);
      fill.style.width = pct2 + '%';
      track.setAttribute('aria-valuenow', String(Math.round(pct2)));
      var remaining2 = formatMoney(data.threshold - data.eligible, data.currency);
      msg.innerHTML = 'You\'re <strong>' + remaining2 + '</strong> off FREE shipping.';
      return;
    }
    // ERROR fallback: safe static message, no numeric claim
    track.hidden = true;
    msg.textContent = 'FREE shipping when you grab 2 decks.';
  }

  function refresh() {
    if (!el) return;
    if (abortCtrl) abortCtrl.abort();
    abortCtrl = new AbortController();

    fetch(cartUrl(), { credentials: 'same-origin', signal: abortCtrl.signal })
      .then(function (r) { if (!r.ok) throw new Error('cart fetch failed'); return r.json(); })
      .then(function (cart) {
        var threshold = THRESHOLDS[cart.currency];
        if (threshold === undefined) { render('CURRENCY_FALLBACK'); return; }

        var dpInCart = cart.items.some(function (i) { return String(i.variant_id) === DP_VARIANT; });
        var eligible = cart.items.reduce(function (sum, i) {
          return DEFAULT_PROFILE.indexOf(String(i.variant_id)) === -1 ? sum : sum + i.line_price;
        }, 0);

        // Projection: the selected quantity on this PDP counts toward the threshold,
        // even when the cart is empty (the first-visit upsell moment).
        if (currentVariantId && DEFAULT_PROFILE.indexOf(currentVariantId) !== -1) {
          var qtyInput = document.querySelector('.quantity__input');
          var inCartQty = cart.items.reduce(function (sum, i) {
            return String(i.variant_id) === currentVariantId ? sum + i.quantity : sum;
          }, 0);
          var selected = qtyInput ? parseInt(qtyInput.value, 10) || 0 : 0;
          if (selected > inCartQty) {
            var line = cart.items.filter(function (i) { return String(i.variant_id) === currentVariantId; })[0];
            var unitPrice = line ? Math.round(line.line_price / line.quantity) : currentUnitPrice;
            if (!unitPrice || unitPrice <= 0) unitPrice = 2295;
            eligible += (selected - inCartQty) * unitPrice;
          }
        }

        if (cart.item_count === 0 && eligible === 0) { render('EMPTY'); return; }
        if (dpInCart && eligible === 0) { render('DP_ONLY'); return; }
        if (dpInCart && eligible > 0 && eligible < threshold) {
          render('DP_PARTIAL', { eligible: eligible, threshold: threshold, currency: cart.currency });
          return;
        }
        if (eligible >= threshold) { render('UNLOCKED'); return; }
        render('PROGRESS', { eligible: eligible, threshold: threshold, currency: cart.currency });
      })
      .catch(function (e) {
        if (e.name === 'AbortError') return;
        console.warn('ftg-fsbar: cart refresh failed', e);
        render('ERROR');
      });
  }

  function init() {
    el = document.getElementById('ftg-fsbar');
    if (!el || el.dataset.ftgFsbarInit === '1') return;
    el.dataset.ftgFsbarInit = '1';

    DP_VARIANT = el.dataset.doublePackVariant;
    DEFAULT_PROFILE = (el.dataset.defaultProfileVariants || '').split(',').filter(Boolean);
    currentVariantId = el.dataset.currentVariant || null;
    currentUnitPrice = parseInt(el.dataset.unitPrice, 10) || null;

    // Native ATC (product-form.js) publishes via the theme's in-memory pub/sub (subscribe/publish),
    // NOT DOM events. The custom cross-sell/sticky JS dispatches a real CustomEvent('cart:refresh').
    if (typeof subscribe === 'function') { subscribe('cart-update', refresh); }
    document.addEventListener('cart:refresh', refresh);
    window.addEventListener('pageshow', function (e) { if (e.persisted) refresh(); });

    // Quantity selector changes should re-project the bar immediately
    var qtyInput = document.querySelector('.quantity__input');
    if (qtyInput) {
      qtyInput.addEventListener('change', refresh);
      qtyInput.addEventListener('input', refresh);
    }

    refresh();
  }

  document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();
